import { shopifyAppSlug } from '../../../constants/environment';
import type { Env } from '../../../context/env-context';

export const isShopify = (platform: Env['platform']): boolean =>
  platform === 'shopify' || platform === 'shopify_plus';

export const isWix = (platform: Env['platform']): boolean => platform === 'wix';

export const isWoocommerce = (platform: Env['platform']): boolean => platform === 'woocommerce';

/** Shopify admin deep-link to the app's theme-setup screen, or null without a store. */
export function themeSetupUrl(env: Env): string | null {
  return env.store_id ? `https://${env.store_id}/admin/apps/${shopifyAppSlug}/theme-setup` : null;
}
